import { useField } from 'formik';
import React from 'react';
import Select from 'react-select';

interface IProps {
  children: React.ReactNode;
  className: string;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  options: any[];
  changeHandler?: (value: any) => void;
  loading?: boolean;
  isLabelValueSame: boolean;
  isClearable?: boolean;
}

const FormikFormSelectField = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  return (
    <>
      <Select
        {...field}
        isClearable={props.isClearable ?? false}
        options={props.options}
        onChange={(e: any) => {
          helpers.setValue(e);
        }}
        isLoading={props.loading}
        menuPortalTarget={document.body} // render menu outside container
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
      {meta.touched && meta.error && (
        <span className="invalid-feedback">{meta.error}</span>
      )}
    </>
  );
};

export default FormikFormSelectField;
